import React from 'react';
import Button from '@material-ui/core/Button';
import { IconButton } from '@material-ui/core';
import { Modal, Row, Col } from 'react-bootstrap';
import CloseIcon from '@material-ui/icons/Close';
import { getSessionStorageItem } from '../../sessionStorage';
import '../Product/SharedComponents/BasicInfo/InsuredBasicInfo.scss';

export default function RequestSession(props) {
    const {show, onHide, sessionKey, href, onSessionStore, isSessionStore, scheduleSessionKey} = props;

    const onSessionConfirmation = (isnew) =>{
        if(isnew){
            if(isSessionStore){
                onSessionStore();
            }
            sessionStorage.removeItem(sessionKey);
            if(scheduleSessionKey){
                sessionStorage.removeItem(scheduleSessionKey);
            }
        }
        onHide();
        window.location.href = href;
    }

    const getClientName = () => {
        var client = '';
        var clientData = getSessionStorageItem(sessionKey);
        if(clientData && clientData.pages.clientType && clientData.pages.clientType.clientName){
            client = clientData.pages.clientType.clientName;
        }

        else{
            if(clientData && clientData.pages.clientType && clientData.pages.clientType.clientInfo && clientData.pages.clientType.clientInfo.customerDetails){
                var customerData =  clientData.pages.clientType.clientInfo.customerDetails;
                if(Array.isArray(customerData) && customerData.length > 0){
                    var clientNames = customerData[0].firstName + " " +customerData[0].lastName;
                    client = clientNames;
                }
            }
        }
        return client;
    }

    return (
        <Modal {...props} className="insured-info-content" show={show} onHide={onHide} animation={false} centered>
            <Modal.Body className="d-flex align-items-center justify-content-center p-3 flex-column">
                <div className='head-close'>
                <h4>Continue Existing Transaction?</h4>
                    <IconButton className="close-button" aria-label="close" onClick={onHide}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <p className='pb-4 pt-2'>Would you like continue where you left off with <b>{getClientName()}</b> or would you like to start a new transaction?</p>
                <Row className="modal-btn">
                    <Col>
                        <Button
                            className='text-center btn-continue'
                            variant="outlined"
                            size="large"
                            type="submit"
                            color="primary"
                            onClick={() => onSessionConfirmation(true)}
                        >
                        NEW
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            className='text-center btn-continue'
                            variant="contained"
                            size="large"
                            type="submit"
                            color="primary"
                            onClick={() => onSessionConfirmation()}
                        >
                        CONTINUE
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/components/Common/RequestSession.js